import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { orderBy, tail, take } from 'lodash'
import noPicture from 'assets/pictures/noPicture.png'
import i18n from 'simple-react-i18n'
import DtoPicture from '../../station/dto/DtoPicture'
import { contentsPath } from '../../conf/basepath'
import Fancybox from 'components/fancybox/Fancybox'
import { Grid, Card, CardContent } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import useSandreList from 'utils/customHook/useSandreList'
import { SANDRE } from 'referencial/constants/ReferencialConstants'

const SmallPicturePanel = ({
    pictures = [],
    showTitle = false,
}) => {
    const types = useSandreList(SANDRE.TYPE_PHOTO)

    const createPicture = (picture, isFirst = false) => {
        const url = picture.url.startsWith('http') ? picture.url : `${contentsPath}${picture.url}`
        if (isFirst) {
            return (
                <Fancybox>
                    <a href={url} data-fancybox='images'
                        data-caption={picture.name}
                    >
                        <img src={url} className='first-picture' />
                    </a>
                </Fancybox>
            )
        }
        return (
            <Grid>
                <Fancybox>
                    <a href={url} data-fancybox='images'
                        data-caption={picture.name}
                    >
                        <img src={url} className='small-picture' />
                    </a>
                </Fancybox>
            </Grid>
        )
    }

    const picturesWithRef = useMemo(() => orderBy(pictures.map(p => ({
        ...p,
        ref: types.find(t => (t.mnemonique || t.name) === p.type)?.reference,
    })), ['ref', 'date'], ['asc', 'desc']), [pictures, types])

    const getFirstPicture = () => {
        const picture = {
            name: i18n.noPicture,
            url: noPicture,
        }
        if (pictures.length > 0) {
            return createPicture(picturesWithRef[0], true)
        }
        return createPicture(picture, true)
    }

    return pictures.length > 0 && (
        <Card>
            {showTitle && (
                <CardTitle title={i18n.pictures} />
            )}
            <CardContent>
                <Grid container direction='column' alignItems='center' justifyContent='center'>
                    <Grid>
                        {getFirstPicture()}
                    </Grid>
                    <Grid className='padding-top-1 padding-bottom-1' container alignItems='center' justifyContent='space-evenly' spacing={1}>
                        {take(tail(picturesWithRef), 3).map(picture => createPicture(picture))}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

SmallPicturePanel.propTypes = {
    element: PropTypes.string,
    pictures: PropTypes.arrayOf(PropTypes.instanceOf(DtoPicture)),
    showTitle: PropTypes.bool,
}

export default SmallPicturePanel